/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface slidesStruct {
  heading ? : string;
  content ? : string;
}
export default interface Accordion {
  slides ? : Array < slidesStruct > ;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  slides: Array as() => Array < slidesStruct > ,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  slides: Object,
  dataABId: String,
  metadata: Object,
}

export class AccordionBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class AccordionInstance implements Accordion {
      slides ? : Array < slidesStruct > ;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.slides) {
          this.slides = Object.entries(this.slides)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'slides' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
        } else {
          this.slides = null as any;
        }
      }
    }
    return new AccordionInstance(props);
  }
}
